import { SET_AUTH, REMOVE_AUTH } from "../actions";

const initialState = {
  authenticated: false,
  id: null,
  name: "",
  email: "",
  role: "",
  permissions: [],
  token: null,
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTH:
      return {
        ...state,
        authenticated: true,
        ...action.payload,
      };
    case REMOVE_AUTH:
      return { ...initialState };
    default:
      return state;
  }
};

export default rootReducer;
